import { EntityNames } from 'src/core/router/EntityLinks';

type FeatureList = EntityNames;

export const featureList: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    [key in FeatureList]: {
        unavailable: boolean;
    };
} = {
    index: {
        unavailable: false,
    },
    partners: {
        unavailable: false,
    },
    merchants: {
        unavailable: false,
    },
    loanApplications: {
        unavailable: false,
    },
    transaction: {
        unavailable: false,
    },
};
